<template>
  <div class="koc-pagination-component">
    <button
      :disabled="state.showingFirst"
      class="koc-button koc-ripple"
      @click="firstPage()"
    >
      <font-awesome-icon
        class="next-page"
        icon="angles-left"
      />
    </button>
    <button
      :disabled="state.showingFirst"
      class="koc-button koc-ripple"
      @click="prevPage()"
    >
      <font-awesome-icon
        class="next-page"
        icon="arrow-left"
      />
    </button>
    <button
      v-for="page in state.pages"
      :key="page"
      :class="{ 'koc-clear': isCurrentPage(page) }"
      :disabled="isCurrentPage(page)"
      class="koc-button koc-ripple"
      @click="setPage(page)"
    >
      {{ page }}
    </button>
    <button
      :disabled="state.showingLast"
      class="koc-button koc-ripple"
      @click="nextPage()"
    >
      <font-awesome-icon
        class="next-page"
        icon="arrow-right"
      />
    </button>
    <button
      :disabled="state.showingLast"
      class="koc-button koc-ripple"
      @click="lastPage()"
    >
      <font-awesome-icon
        class="next-page"
        icon="angles-right"
      />
    </button>
  </div>
</template>

<script src="./pagination.js"></script>
<style lang="scss" scoped src="./pagination.scss"></style>
